<section>
    <h2>Do Your Own Research</h2>
    <p>In the crypto ecosystem, security is paramount. Do your own research (DYOR) and learn about the assets you are "investing" your time and money into.</p>
    <p>You can find more information about our token through the links below.</p>
    <div class="buy-links-container">
        <div class="buy-link">
            <a style="background: #1c2936;" href="https://solscan.io/token/4zyE51eWthh21ZNBB5rymdV3Pgen2DXH7HiLdfi2AKtX" target="_blank" rel="noopener noreferrer" class="buy-button">
                <img src="/images/solscan_logo.png" alt="Solscan" class="button-image"/>
                <span class="button-text">SolScan</span>
            </a>
        </div>

        <div class="buy-link">
            <a style="background: #000000;" href="https://rugchecker.com/tokens/4zyE51eWthh21ZNBB5rymdV3Pgen2DXH7HiLdfi2AKtX" target="_blank" rel="noopener noreferrer" class="buy-button">
                <img src="/images/rugcheck_logo.webp" alt="RugCheck" class="button-image"/>
                <span class="button-text">RugCheck</span>
            </a>
        </div>
    </div>
</section>

<style>
    section {
        min-height: 100vh; /* Full viewport height */
        display: flex;
        flex-direction: column;
        justify-content: center; /* Centers content vertically */
        align-items: center; /* Centers content horizontally */
        padding: 2rem;
        text-align: center;
    }

    h2 {
        font-size: 1.8rem;
        margin-bottom: 1rem;
    }

    p {
        font-size: 18pt;
        line-height: 1.5;
        margin-bottom: 1.5rem;
    }

    .buy-links-container {
        display: flex;
        gap: 1rem;
    }

    .buy-button {
        display: flex;
        align-items: center;
        padding: 10px 20px;
        background-color: #007bff; /* Customize your button color here */
        color: white;
        border-radius: 50px; /* Rounded look */
        text-decoration: none; /* Remove link underline */
        font-size: 1rem;
        font-weight: 500;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    }

    .buy-button:hover {
        background-color: #0056b3; /* Darken on hover */
        transform: translateY(-2px); /* Lift effect */
        box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.3);
    }

    .button-image {
        width: 24px; /* Adjust size as needed */
        height: 24px;
        margin-right: 8px;
    }

    .button-text {
        display: inline-block;
    }

    label {
        font-size: 1rem;
    }

    input[type="number"] {
        width: 80px;
        padding: 0.3rem;
        font-size: 1rem;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    button {
        padding: 0.5rem 1rem;
        font-size: 1rem;
        color: #fff;
        background-color: #007bff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    button:hover {
        background-color: #0056b3;
    }
</style>
